import {useMap} from "@vis.gl/react-google-maps";
import {useEffect} from "react";

export function FitBounds({ markers, mapZoomController}) {
    const map = useMap();

    useEffect(() => {
        if (!map || !markers?.length) return;
        if(mapZoomController.current > 0) return;

        const bounds = new google.maps.LatLngBounds();

        markers.forEach(marker => {
            bounds.extend({
                lat: marker.lat,
                lng: marker.lng,
            });
        });

        if (markers.length === 1) {
            map.setCenter(bounds.getCenter());
            map.setZoom(14);
        } else {
            map.fitBounds(bounds, {
                top: 50,
                bottom: 50,
                left: 50,
                right: 50,
            });
        }
        mapZoomController.current = 1;

    }, [map, markers]);

    return null;
}